import { Component, inject, OnInit } from '@angular/core';
import { AppInformationService, ArkUnitOfWork, AuthService } from 'app/core/core.module';
import { AuctionItem } from 'app/core/model/auction-item';
import { AuctionPurchase } from 'app/core/model/entity-model';
import { Person } from 'app/core/model/person';
import _ from 'lodash';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { default as validationEngine } from 'devextreme/ui/validation_engine';

@Component({
    selector: 'app-auction-item-dialog',
    templateUrl: './auction-item-dialog.component.html',
    styleUrls: ['./auction-item-dialog.component.scss'],
})
export class AuctionItemDialogComponent implements OnInit {
    private appInfo = inject(AppInformationService);

    result: Subject<any> = new Subject<any>();
    auctionItem: AuctionItem;
    auctionItemTypes = ['Live', 'Silent', 'Raffle Line'];
    people: Person[];
    auctionPaddleInfos: any[];
    purchase: AuctionPurchase;
    selectedPaddle: any;
    validationGroup = 'mainValidationGroup';
    errorAction = 'saving';

    constructor(public modalRef: BsModalRef, private uow: ArkUnitOfWork, private auth: AuthService) {}

    async ngOnInit() {
        if (!this.auctionItem) {
            this.auctionItem = this.uow.auctionItems.createEntity({
                created: new Date(),
                createdBy: this.auth.currentUser.userName,
                linePrice: 0,
                marketValue: 0,
                minimumBid: 0,
            }) as AuctionItem;
        }
    }

    // itemChanged(e) {
    //     console.log(e);
    //     if (!!e.value) {
    //         const item = _.find(this.auctionItems, { id: e.value });
    //         if (!!item.linePrice) {
    //             this.purchase.amount = item.linePrice;
    //         } else {
    //             this.purchase.amount = 0;
    //         }
    //     }
    // }

    async save() {
        const result = this.validate();
        if (!result) return;

        if (this.auctionItem.linePrice === 0) this.auctionItem.linePrice = null;
        if (this.auctionItem.marketValue === 0) this.auctionItem.marketValue = null;
        if (this.auctionItem.minimumBid === 0) this.auctionItem.minimumBid = null;

        await this.uow.commit();
        this.result.next({ success: true });
    }

    validate() {
        const groupConfig = validationEngine.getGroupConfig(this.validationGroup);
        if (groupConfig) {
            const result = validationEngine.validateGroup(this.validationGroup);
            if (!result.isValid) {
                let message = '';
                result.brokenRules.forEach((brokenRule) => {
                    if (brokenRule.type === 'custom') message = `${brokenRule.message}\n${message}`;
                });
                this.appInfo.notifyToast(`Please fix errors before ${this.errorAction}.\n\n${message}`, 'error');
                return false;
            }
        }
        return true;
    }

    close() {
        this.uow.rollback();
        this.result.next({ success: false });
    }
}
